import { create } from "zustand";

type Todo = {
  id: string;
  title: string;
  deadline: string;
  description: string;
  files: string[];
  recipients: {
    _id: string;
    name: string;
  }[];
} | null;

interface HookProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;

  todoId: string;
  setTodoId: (id: string) => void;

  todo: Todo;
  setTodo: (t: Todo) => void;
}

export const useTodoStatusViewModal = create<HookProps>()((set) => ({
  open: false,
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),

  todoId: "",
  setTodoId: (id) =>
    set(() => ({
      todoId: id,
    })),

  todo: null,
  setTodo: (todo) =>
    set(() => ({
      todo,
    })),
}));
